module.exports = __webpack_public_path__ + "48088acb75eb6db46ac386d1ee316ef8.webp";